module.exports = __webpack_public_path__ + "static/img/Example-icon2.8f9bbc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Example-icon2.jpg
// module id = JdAV
// module chunks = 1